import { computed, Signal, signal } from '@angular/core';
import { Dictionary } from '../../types/dictionary';

export interface DictionaryServiceOptions<T> {
  defaultValue?: Dictionary<T>;
}

export class DictionaryService<T> {

  protected _dict = signal<Dictionary<T>>({});

  dict = this._dict.asReadonly();
  keys = computed(() => Object.keys(this._dict()));
  values = computed(() => Object.values(this._dict()));
  value = (key: string | number): Signal<T | undefined> => computed(() => this._dict()[key] ?? undefined);

  constructor(private options: DictionaryServiceOptions<T> = {}) {
    if(options.defaultValue)
      this._dict.set(options.defaultValue);
  }

  setValue = (key: string | number, value: T): void => {
    const dict = {...this._dict()};
    dict[key] = value;
    this._dict.set(dict);
  }

  removeValue = (key: string | number): void => {
    const dict = {...this._dict()};
    delete dict[key];
    this._dict.set(dict);
  }

  clear = (): void => {
    this._dict.set({});
  }

  reset = (): void => {
    this._dict.set(this.options.defaultValue ?? {});
  }
}
